import { create, registerPlugin } from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

registerPlugin(FilePondPluginImagePreview);

export default {
    /**
     * @param {string|HTMLElement} inputTarget - selector or element for <input type="file">
     * @param {string|HTMLElement} hiddenTarget - selector or element for hidden input to receive the uploaded file URL
     * @param {Object} options
     * @param {string} options.uploadUrl - backend endpoint
     */
    initCoverUploader(inputTarget, hiddenTarget, { uploadUrl }) {
        const inputEl = typeof inputTarget === 'string' ? document.querySelector(inputTarget) : inputTarget;
        const hiddenEl = typeof hiddenTarget === 'string' ? document.querySelector(hiddenTarget) : hiddenTarget;

        if (!inputEl || !hiddenEl) return null;

        const pond = create(inputEl, {
            credits: false,
            allowMultiple: false,
            acceptedFileTypes: ['image/*'],
            server: {
                process: {
                    url: uploadUrl,
                    method: 'POST',
                    onload: (responseText) => {
                        // We return the URL as the "serverId" so FilePond keeps it around.
                        const data = JSON.parse(responseText);
                        return data.url;
                    },
                },
            },
        });

        pond.on('processfile', (error, file) => {
            if (error) return;
            hiddenEl.value = file.serverId || '';
        });

        pond.on('removefile', () => {
            hiddenEl.value = '';
        });

        return pond;
    },
};


